module.exports = __webpack_public_path__ + "img/red-close-icon.dcc647a6.svg";